import PrintPageWrapper from "./PrintPageWrapper";

export default PrintPageWrapper;